import React from 'react'
import { FormattedMessage } from 'react-intl'
import config from '../../../config'
import {
  CookiesBoxWrapper,
  ReadMore,
  Text,
  Button
} from './CookiesBoxStyledComponents'

interface Props {
  onAccept: () => void
  className?: string
}

const CookiesBox = React.memo(({ onAccept, className }: Props) => (
  <CookiesBoxWrapper className={`${className}`}>
    <Text className='d-none d-sm-block'>
      <FormattedMessage id='cookiesBox.pageUsingCookies' />
      <ReadMore to={config.privacyPolicyUrl}>
        <FormattedMessage id='cookiesBox.readMore' />
      </ReadMore>
    </Text>
    <Text className='d-sm-none'>
      <FormattedMessage id='cookiesBox.cookiePolicy' />
      <ReadMore to={config.privacyPolicyUrl}>
        <FormattedMessage id='cookiesBox.readMore' />
      </ReadMore>
    </Text>
    <Button color='primary' size='sm' onClick={() => onAccept()}>
      <FormattedMessage id='cookiesBox.agree' />
    </Button>
  </CookiesBoxWrapper>
))

CookiesBox.displayName = "CookiesBox"

export default CookiesBox